import axios from 'axios';
import PopupTools from 'popup-tools';

const reloadWindow = () => window.location.reload();

export const loginWithThirdParty = (
  {
    url = '',
    type,
    redirect = '',
    title = '',
    data = {},
    pageCategory = '',
    showAsSignUp = false,
    onClosePopup = () => {},
    enablePostSignUpSurvey = false,
  },
  callback
) => {
  PopupTools.popup(url, title, data, (err, user) => {
    if (err) {
      console.error({
        msg: `Error occurred in ${type} connect`,
        err,
      });
    } else {
      if (user) {
        const category = user.isNewUser ? `${type} Sign Up` : `${type} : Sign In`;
        // Create the event
        const evt = document.createEvent('CustomEvent');
        const eventData = {
          category,
        };
        evt.initCustomEvent(window.Event.signIn, false, false, eventData);
        document.dispatchEvent(evt);
        // If Login Popup was opened for saving a job then we don't need to redirect to any page
        // Instead we do need to open LocationInput popup for displaying that our job is saved.
        if (!(showAsSignUp || (user?.isNewUser && enablePostSignUpSurvey))) {
          if (user.isNewUser && !user.major) {
            // Send the user to fill his major.
            window.location.href = '/find-your-best-job/';
          } else if (user.lastSurveyFlow && pageCategory === 'Home') {
            window.location.href = '/matches/';
          } else if (redirect) {
            window.location.href = redirect;
          } else {
            if (!onClosePopup) reloadWindow();
          }
        }
      }
      callback && callback(user);
    }
  });
};

export const oneTapGoogleLogin = (credential) => {
  const pageCategory = window ? window.pageCategory : '';
  return axios('/auth/google/onetap', { params: { credential, pageCategory } })
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
